import { Directive, effect, input, signal } from '@angular/core'

import { theme } from '@flowx/core-sdk'
import { BulkFileUploadStyles, applyBulkFileUploadCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-bulk-file-upload',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxBulkFileUploadStyleDirective {
  componentStyle = input<{
    style: BulkFileUploadStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyBulkFileUploadCustomStyles(this.componentStyle().style, theme())
      this.styleClassName.set(className)
    })
  }
}
